import { render, staticRenderFns } from "./SensorDetailInfo.vue?vue&type=template&id=2875b824&functional=true&"
import script from "./SensorDetailInfo.vue?vue&type=script&lang=js&"
export * from "./SensorDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports